import { AMLS_TM_IAD } from './globalConstants';

const TOKEN_ID = (localStorage && localStorage.getItem('id_token')) || '';
const PRODUCT_ID = (localStorage && localStorage.getItem('productId')) || '';

export const TRM_CONSTANTS = {
  TRM_BASE_URL: AMLS_TM_IAD,
  HTTP_HEADERS: Object.freeze({
    'Content-Type': 'application/json',
    'X-HTTP-Method-Override': 'PUT',
    // Authorization: `${TOKEN_ID}`,
    Authorization: `Bearer ${TOKEN_ID}`,
    ProductId: PRODUCT_ID
  }),
  GET_SUCCESS_DATA: 'getSuccessData',
  GET_FAILURE_DATA: 'getFailData',
  GET_DATA: 'getData',
  YET_TO_START: 'Yet to Start',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  IN_QUEUE: 'InQueue',
  YES: 'Yes',
  NO: 'No'
};

// FIN-12282: Action Catalog must NOT appear for Transaction Monitoring IAD.
// It stays in the fraud-capable lists below (FIN-12207 — its typology-action
// weights feed FP scoring), so only TM-only users lose it.
export const TM_IAD_TAB_LIST = ['TM IAD'];
export const TM_IAD_TAB_PAGEID_LIST = ['TM_IAD_ALERTS_DETAILS'];
export const TM_IAD_ACTION_CATALOG_PAGE_ID = 'TM_IAD_ACTION_CATALOG';
// FIN-12215: tenant-level default scoring config (Settings > Scoring). Fraud-scoped
// (backed by the FRAUD_PREVENTION global default), so it is only added to the
// fraud-capable tab lists below.
export const TM_IAD_SCORING_DEFAULTS_PAGE_ID = 'TM_IAD_SCORING_DEFAULTS';
// FIN-12421 Item 7: FRAML settings — tenant-level `framl_decay_policy` (weights,
// decay half-life, sigmoid params, multiplier maps, load window). Same scope as
// Scoring above; controller mount is gated on `amls.framl.scoringEnabled`, so a
// deployment with scoring off returns 404 on the endpoint and the tab pane
// renders a "not enabled" state.
export const TM_IAD_FRAML_SETTINGS_PAGE_ID = 'TM_IAD_FRAML_SETTINGS';
// Event Fields (Spatial View) tab. Index MUST match its position in the tab lists
// below — the label list and the page-id list are read by index, so appending to
// one without the other silently mislabels every tab after it.
export const TM_IAD_EVENT_FIELDS_PAGE_ID = 'TM_IAD_EVENT_FIELDS';
export const CUSTOMER_MATCHING_TABL_LIST = ['Create New Set'];
export const TM_IAD_TAB_MODULE_ID = '3';
export const TM_IAD_TAB_SUBMODULE = 'global';
export const TM_IAD_TAB_MODULE_NAME = 'TM-IAD';

// FIN-12282: per-product head-tab titles for the TRM Settings page.
export const TM_IAD_SETTINGS_TITLE =
  'Global Setting for Transaction Monitoring IAD';
export const FRAUD_IAD_SETTINGS_TITLE = 'Global Setting for Fraud Prevention';

// FIN-12207: fraud-only users (isFraud && !isTMuser) must also see the Action
// Catalog tab — its typology-action weights (ALLOW/SOFT STOP/STOP/REJECTED) feed
// FP scoring (ADR 0003/0004), so a fraud admin needs it. Index positions must stay
// aligned with FRAUD_IAD_TAB_PAGEID_LIST.
//
// FIN-13776: the 'Fraud' (UI Settings) tab — page FRAUD_IAD_ALERTS_DETAILS — is no
// longer offered on the Fraud Prevention pane. Its config is read only by the CM
// alert detail of Fraud Detection (FRAUDIAD) alerts; no Fraud Prevention screen
// consumes it (RTFRAUDIAD/_BATCH render via FramlAlertDetailRouter with hardcoded
// widget settings). The DB rows are untouched. The pane now lands on Action Catalog.
// TM IAD keeps its own UI Settings tab (TM_IAD_TAB_LIST above).
export const FRAUD_IAD_TAB_LIST = [
  'Action Catalog',
  'Scoring',
  // FIN-12421 Item 7 — FRAML Settings tab. Index MUST match TM_IAD_FRAML_SETTINGS_PAGE_ID
  // position in FRAUD_IAD_TAB_PAGEID_LIST below.
  'FRAML Settings',
  // Event Fields (Spatial View) — sits after FRAML Settings, per the design.
  'Event Fields'
];
export const FRAUD_IAD_TAB_PAGEID_LIST = [
  'TM_IAD_ACTION_CATALOG',
  'TM_IAD_SCORING_DEFAULTS',
  'TM_IAD_FRAML_SETTINGS',
  'TM_IAD_EVENT_FIELDS'
];

// FIN-12282: module identity for the Fraud Prevention head-tab. `moduleId` is the
// Gladiator AAA `modules.id` (12 = 'Fraud Prevention'; TM IAD is 3) — the Pipelines
// page passes it to GET /pipelines?moduleId=, where the BE resolves both the TDSS
// connection (TdssConfigConstants.moduleIdConfKey) and the module's
// `pipelines_pattern`. Without it the fraud pane would call the endpoint with
// moduleId=undefined and get 400 "param 'moduleId' needed".
export const FRAUD_IAD_TAB_MODULE_ID = '12';
export const FRAUD_IAD_TAB_SUBMODULE = 'global';
export const FRAUD_IAD_TAB_MODULE_NAME = 'Fraud Prevention';

export const TM_FRAUD_IAD_TAB_LIST = [
  'TM IAD',
  'Fraud',
  'Action Catalog',
  'Scoring',
  'FRAML Settings',
  'Event Fields'
];
export const TM_FRAUD_IAD_TAB_PAGEID_LIST = [
  'TM_IAD_ALERTS_DETAILS',
  'FRAUD_IAD_ALERTS_DETAILS',
  'TM_IAD_ACTION_CATALOG',
  'TM_IAD_SCORING_DEFAULTS',
  'TM_IAD_FRAML_SETTINGS',
  'TM_IAD_EVENT_FIELDS'
];

export const TRM_BASE_ROUTE = '/app/trm';
